import { aggregatedSentiments } from '@/metrics/pages/ReasonMetricDetailPage/constants'
import { getSentimentTypes } from '@/metrics/pages/ReasonMetricDetailPage/helpers'

import { defaultSentimentFilter } from '../hooks/useTopicNotes/constants'

const getSentimentOption = (sentiment, theme) => {
  const sentimentTypes = getSentimentTypes(theme)

  return {
    value: sentiment,
    label: sentimentTypes[sentiment].label,
    Icon: sentimentTypes[sentiment].Icon,
    iconColor: sentimentTypes[sentiment].iconColor,
  }
}

export const getFilterOptions = theme => {
  return [
    { value: defaultSentimentFilter, label: 'Todo' },
    getSentimentOption(aggregatedSentiments.positive, theme),
    getSentimentOption(aggregatedSentiments.neutral, theme),
    getSentimentOption(aggregatedSentiments.negative, theme),
  ]
}
